export class SupportIntegrationUrlConfig {
    public static Endpoints = {
        supportIntegrationBaseUrl: '/solution/support-integration?requestPath=',
        feedback:{
            getReportDetails : '/incidentreport/getincidentreportdetails?filter={params}',
            getDocumentList : '/document/list?filter={params}',
            addAttachment : '/document/adddocumentdetail',
            addIncidentReport : '/incidentreport/addincidentreportdetail',
        },
        ticket:{
            generateTicket : '/incidentreport/generateticket',
            getReportList : '/incidentreport/list?filter={params}',
            getProjectInfo : '/incidentreport/getprojectinfo'
        }
    }
}